import { render } from "./RecursoComp.vue?vue&type=template&id=f88fd084&scoped=true"
import script from "./RecursoComp.vue?vue&type=script&lang=js"
export * from "./RecursoComp.vue?vue&type=script&lang=js"

import "./RecursoComp.vue?vue&type=style&index=0&id=f88fd084&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f88fd084"]])

export default __exports__